import { cn } from "@/shared/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/ui/tooltip";

const SIGNED_PCT_FMT = new Intl.NumberFormat("en-US", {
  signDisplay: "exceptZero",
  maximumFractionDigits: 0,
});

export type PriceDeltaTone = {
  name: string;
  label?: string | null;
  percent_delta: number | null;
  level?: number;
};

export function PriceDeltaPill({
  tone,
  alwaysShow = false,
  tooltip,
}: {
  tone: PriceDeltaTone | null | undefined;
  alwaysShow?: boolean;
  tooltip?: string;
}) {
  const delta = tone?.percent_delta ?? null;

  if (delta == null || Math.abs(delta) < 3) return null;
  if (!alwaysShow && (!tone || tone.name === "neutral")) return null;

  const isAbove = tone?.name === "above";
  const isBelow = tone?.name === "below";

  const pill = (
    <span
      className={cn(
        "inline-flex h-5 items-center rounded-full px-2 text-[10px] leading-none font-semibold tabular-nums",
        isAbove && "bg-rose-100 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300",
        isBelow && "bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300",
        !isAbove && !isBelow && "bg-muted text-muted-foreground",
      )}
    >
      {SIGNED_PCT_FMT.format(Math.round(delta ?? 0))}%
    </span>
  );

  if (!tooltip) return pill;

  return (
    <Tooltip>
      <TooltipTrigger asChild>{pill}</TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}
